import React, { Fragment, memo, useEffect, useState } from 'react';
import { safeGet } from '../../axios-default';
import ApiServerUrl from '../../config.json';

const colorList = {
    'Lower Dentition': '#FFFFFF',
    'Pre-TrioClear Dentition': '#00FFF0',
    'Smile Design': '#FFFFFF',
    'Patient 2D Photo': '#EBEBEB',
    'Post-TrioClear Dentition': '#FFFFFF',
};

const ColorIndicator = () => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginBottom: 4, marginLeft: 4 }}>
            {Object.entries(colorList).map(([key, value]) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', paddingRight: 20 }} key={key.trim()}>
                        <div
                            style={{
                                backgroundColor: value,
                                height: '20px',
                                width: '20px',
                                marginRight: 4,
                                borderRadius: '5px',
                                borderColor: 'black',
                                borderWidth: 1,
                                borderStyle: 'solid',
                            }}
                        />
                        <div>{key}</div>
                    </div>
                );
            })}
        </div>
    );
};

const SmileDesignHTML = ({ link = '', height = '500px' }) => {
    const [html, setHTML] = useState({ __html: '' });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        async function createMarkup() {
            setIsLoading(true);
            try {
                const response = await safeGet(link);
                setIsLoading(false);

                if (response) {
                    if (response.success === false) {
                        return {
                            isBox: true,
                            msg: 'No ISD File found'
                        };
                    }

                    return { __html: response };
                }
            } catch (error) {
                setIsLoading(false);
                return { isBox: true, msg: 'Error loading content' };
            }
        }

        const htmlRegex = /.+\.html/i;
        if (htmlRegex.test(link)) {
            createMarkup().then((result) => setHTML(result));
        } else {
            setHTML({
                isBox: true,
                msg: 'No ISD File found'
            });
        }
    }, [link, height]); // Added height dependency since it's used inside the effect lifecycle

    return (
        <>
            {isLoading && <div style={{ border: 'none', width: '100%', height: height }}>Loading...</div>}

            {!isLoading && html?.isBox ? (
                <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center', fontSize: '16px', color: '#808080', width: '100%', fontWeight: 600, boxSizing: 'border-box' }}>
                    {html.msg}
                </div>
            ) : (
                <iframe
                    title="HTML Content"
                    srcDoc={html?.__html || ''}
                    style={{ display: isLoading ? 'none' : '', border: 'none', width: '100%', flex: 1, }}
                />
            )}
        </>
    );
};

export default memo(SmileDesignHTML);